import React from "react";
import VerifiedIcon from "@mui/icons-material/Verified";
import DiamondIcon from "@mui/icons-material/Diamond";

import { colors } from "../../config/colors";

interface SubscriberBadgeProps {
    subscription?: string | null;
}

const SubscriberBadge: React.FC<SubscriberBadgeProps> = ({ subscription }) => {
    if (!subscription) return null;

    return (
        <>
            {subscription === "Lifetime" ? (
                <DiamondIcon
                    className="mr-1 ml-1"
                    fontSize="small"
                    style={{
                        color: colors.gold,
                    }}
                />
            ) : (
                <VerifiedIcon
                    className="mr-1 ml-1"
                    fontSize="small"
                    style={{
                        color:
                            subscription === "Premium"
                                ? colors.gold
                                : colors.button,
                    }}
                />
            )}
        </>
    );
};

export default SubscriberBadge;
